export default __webpack_public_path__ + "static/media/2.183f34cb.jpg";